<template>
  <div>
    <vue-headful
      title="Profile Settings | Gradely.ng - School"
      description="Description goes here"
    />

    <div class="settings-display-layout white rounded-10">
      <!-- PAGE TITLE -->
      <div class="page-title">School Details</div>

      <!-- SCHOOL BANNER -->
      <div class="school-banner w-100">
        <div class="banner-overlay box-overlay brand_inverse_bg rounded-10">
          <img
            v-lazy="banner_img"
            alt="SchoolBanner"
            class="img"
            v-if="banner_img"
          />
          <img
            v-lazy="localImg('ClassDoodle.png')"
            alt="SchoolBanner"
            class="img"
            v-else
          />
        </div>

        <!-- CHANGE PHOTO BUTTON -->
        <div class="form-group banner-input">
          <label for="changeBanner" class="pointer">
            <input
              type="file"
              class="inputFile"
              id="changeBanner"
              accept=".png, .jpg, .jpeg"
              hidden
              ref="bannerInput"
              @change="changeImage($event, 'landscape', 'banner')"
            />
            <div class="d-flex justify-content-around align-items-center">
              <span class="icon icon-camera brand_accent font-17-5 mr-2"></span>
              <div>CHANGE IMAGE</div>
            </div>
          </label>
        </div>
      </div>

      <!-- SCHOOL LOGO SECTION -->
      <div class="school-logo-section">
        <!-- DISPLAY LOGO -->
        <div
          class="avatar avatar-square avatar_xxl rounded-10 brand_inverse_light_bg"
        >
          <img v-lazy="logo_img" alt class="avatar-img" v-if="logo_img" />
          <div class="avatar-text brand_inverse_light_bg brand_primary" v-else>
            {{ getInitial }}
          </div>
        </div>

        <div class="right-section">
          <!-- LOGO INSTRUCTION -->
          <div class="logo-guide">
            <div class="title font-weight-bold color_text">School Logo</div>
            <div class="options">Accepts .png, .jpg or .jpeg</div>
          </div>

          <!-- LOGO CHANGE BUTTON -->
          <div class="logo-change-button">
            <label for="changeLogo" class="btn btn-default-outline btn-md mx-0">
              <input
                type="file"
                class="inputFile"
                id="changeLogo"
                accept=".png, .jpg, .jpeg"
                hidden
                ref="logoInput"
                @change="changeImage($event, 'portrait', 'logo')"
              />
              <div class="d-flex flex-center">
                <div>CHANGE LOGO</div>
              </div>
            </label>
          </div>
        </div>
      </div>

      <!-- PROFILE FORM COMPONENT -->
      <SchoolProfileForm />
      <!-- PROFILE FORM COMPONENT -->
    </div>

    <!-- MODALS -->
    <PhotoCropModal
      v-if="crop_modal"
      :crop_photo="photo_to_crop"
      :photo_check="photo_check"
      :orientation="orientation"
      @closeTriggered="toggleCropModal"
      @updateCroppedLandscapedPhoto="updateUploadedBannerPhoto($event)"
      @updateCroppedPhoto="updateUploadedLogoPhoto($event)"
    ></PhotoCropModal>

    <ResponseDialog
      v-if="response_dialog"
      :alert_msg="alert_card_msg"
      :alert_type="alert_card_type"
      @closeAlert="toggleResponseDialog"
    ></ResponseDialog>
    <!-- MODALS -->
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "SchoolSettingsProfile",

  components: {
    SchoolProfileForm: () =>
      import(
        /* webpackChunkName: "SchoolProfileForm" */ "@/components/globalComps/SettingsComps/ProfileComps/SchoolProfileForm"
      ),
    PhotoCropModal: () =>
      import(
        /* webPackChunkName: "PhotoCropModal" */ "@/components/modalComps/settingsModals/PhotoCropModal"
      ),
    ResponseDialog: () =>
      import(
        /* webpackChunkName: "ResponseDialog" */ "@/components/globalComps/ResponseDialog"
      ),
  },

  computed: {
    ...mapGetters(["getAuthUser"]),

    getInitial() {
      if (
        this.getAuthUser.school_name !== null ||
        this.getAuthUser.school_name !== ""
      )
        return this.getAuthUser.school_name.slice(0, 1);
      else return false;
    },
  },

  data() {
    return {
      banner_img: "",
      logo_img: "",
      banner_file: "",
      logo_file: "",
      photo_to_crop: "",
      valid_types: ["png", "jpg", "jpeg"],
      orientation: "portrait",
      crop_modal: false,
      photo_check: "",

      alert_card_msg: "",
      alert_card_type: "",
      response_dialog: false,
    };
  },

  mounted() {
    this.fetchSchoolDatail();
  },

  methods: {
    ...mapActions(["getSchoolProfile", "uploadToBucket"]),

    toggleResponseDialog() {
      this.response_dialog = !this.response_dialog;
    },

    toggleCropModal() {
      this.crop_modal = !this.crop_modal;
    },

    fetchSchoolDatail() {
      this.getSchoolProfile().then((response) => {
        if (response.code === 200) {
          this.logo_img = response.data.logo;
          this.banner_img = response.data.banner;
        }
      });
    },

    changeImage($event, orientation, type) {
      let file = $event.target.files[0];

      // GET FILE TYPE
      let file_type = file.type.split("/")[1];

      if (this.valid_types.indexOf(file_type) !== -1) {
        if (file.size < 5000000) {
          let reader = new FileReader();
          reader.onload = (evt) => {
            // SHOW CROP MODAL
            this.orientation = orientation;
            this.crop_modal = true;
            this.photo_check = type;
            this.photo_to_crop = evt.target.result;
          };
          reader.readAsDataURL(file);
        } else {
          this.alert_card_msg = "Image size exceeds 5mb";
          this.alert_card_type = "warning";
          this.toggleResponseDialog();
        }
      }
    },

    // UPDATE THE UPDATED LOGO PHOTO AFTER CROP
    updateUploadedLogoPhoto(event) {
      let file_data = {
        folder: "files/logo",
        file: event.data,
        base64: true,
      };

      this.logo_img = event.data;

      this.uploadToBucket(file_data)
        .then((response) => {
          if (response.code === 200) {
            this.$bus.$emit(
              "event-bus-send-logo-file",
              response.data.ObjectURL
            );

            this.alert_card_msg =
              "Click on save button below to effect the changes";
            this.alert_card_type = "warning";
            this.toggleResponseDialog();
          }
        })
        .catch((err) => console.log(err));
    },

    updateUploadedBannerPhoto(event) {
      let file_data = {
        folder: "files/banner",
        file: event.data,
        base64: true,
      };

      this.banner_img = event.data;

      this.uploadToBucket(file_data)
        .then((response) => {
          console.log(response);
          if (response.code === 200) {
            this.$bus.$emit(
              "event-bus-send-banner-file",
              response.data.ObjectURL
            );

            this.alert_card_msg =
              "Click on save button below to effect the changes";
            this.alert_card_type = "warning";
            this.toggleResponseDialog();
          }
        })
        .catch((err) => console.log(err));
    },
  },
};
</script>

<style lang="scss">
// SCHOOL PROFILE SETTINGS
.school-banner {
  position: relative;
  height: 200px;

  @include breakpoint_max(md) {
    height: 150px;
  }

  @include breakpoint_max(sm) {
    height: 130px;
  }

  @include breakpoint_max(xs) {
    height: 110px;
  }

  .banner-overlay {
    background: rgba(0, 0, 0, 0.9);
    overflow: hidden;

    .img {
      @include img_cover;
    }
  }

  .banner-input {
    position: absolute;
    right: 30px;
    bottom: -5px;
    font-weight: 800;
    font-size: 12px;
    line-height: 100%;
    letter-spacing: 0.05em;
    text-transform: uppercase;
    color: $color_white;
    text-shadow: 0 0.25px, 0.25px 0, 0.25px 0.25px;
    transition: all 0.3s ease-in-out;

    @include breakpoint_max(lg) {
      font-size: 11px;
      font-weight: 600;
    }

    @include breakpoint_max(xs) {
      right: 20px;
      bottom: -20px;
    }

    &:hover {
      color: rgb(216, 216, 216);
    }
  }
}

.school-logo-section {
  padding-left: 30px;
  @include flex_row_start_nowrap;
  align-items: flex-start;

  @include breakpoint_max(lg) {
    padding-left: 20px;
  }

  .avatar {
    position: relative;
    top: -70px;
    box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.15);
    margin-right: 30px;

    @include breakpoint_max(lg) {
      top: -50px;
      @include equal_min_edge(110);
    }

    @include breakpoint_max(sm) {
      top: -35px;
      margin-right: 20px;
      @include equal_min_edge(90);
    }

    @include breakpoint_max(xs) {
      top: -20px;
      left: -10px;
      margin-right: 5px;
      @include equal_min_edge(75);
    }

    .avatar-text {
      text-shadow: 0px 0.4px, 0.4px 0px, 0.4px 0.4px;

      @include breakpoint_max(lg) {
        font-size: 56px;
      }

      @include breakpoint_max(sm) {
        font-size: 42px;
      }
    }
  }
}

.right-section {
  @include flex_row_start_wrap;
  align-items: flex-start;
  padding-top: 15px;

  .logo-guide {
    margin-right: 30px;

    @include breakpoint_max(lg) {
      margin-right: 10px;
    }

    @include breakpoint_max(sm) {
      margin-right: 5px;
    }

    .title {
      font-size: 14px;
      line-height: 19px;
      margin-bottom: 4px;

      @include breakpoint_max(lg) {
        font-size: 13px;
      }
    }

    .options {
      font-size: 12px;
      line-height: 16px;
      color: $color_ash;

      @include breakpoint_max(lg) {
        font-size: 11px;
      }
    }
  }

  .btn {
    border: 1px solid $border_grey;
    padding: 13px 34px;

    @include breakpoint_max(lg) {
      padding: 11px 15px;
    }

    @include breakpoint_max(sm) {
      font-size: 10px;
      padding: 10px 13px;
    }
  }
}
</style>
